import { MAX_CENTS, getBalanceInCents } from "./money";

const compareIds = (a, b) => {
  const na = Number(a);
  const nb = Number(b);
  if (Number.isFinite(na) && Number.isFinite(nb) && na !== nb) return na - nb;
  return String(a).localeCompare(String(b));
};

// Ties by id, so the result does not depend on the input order.
const byAmountThenId = (a, b) => b.cents - a.cents || compareIds(a.id, b.id);

export const getSettlements = (participants = []) => {
  const balances = participants
    .map((p) => ({ id: p.id, cents: getBalanceInCents(p) }))
    .filter((b) => b.cents !== 0);

  const debtors = balances
    .filter((b) => b.cents < 0)
    .map((b) => ({ id: b.id, cents: -b.cents }));
  const creditors = balances
    .filter((b) => b.cents > 0)
    .map((b) => ({ ...b }));

  const transfers = [];
  while (debtors.length > 0 && creditors.length > 0) {
    debtors.sort(byAmountThenId);
    creditors.sort(byAmountThenId);
    const debtor = debtors[0];
    const creditor = creditors[0];
    const amount = Math.min(debtor.cents, creditor.cents, MAX_CENTS);

    transfers.push({ fromId: debtor.id, toId: creditor.id, amount });
    debtor.cents -= amount;
    creditor.cents -= amount;
    if (debtor.cents === 0) debtors.shift();
    if (creditor.cents === 0) creditors.shift();
  }
  return transfers;
};
